export default __webpack_public_path__ + "static/media/Puzzle-Sticks-Dino.8e2736fa.jpg";